export { default as QRCodeView } from './qrcode';
